// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const INFO = {
  "dirty": true,
  "raw": "5f72633-dirty",
  "hash": "5f72633",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "5f72633-dirty",
  "semverString": null
};
/* tslint:enable */
